export default __webpack_public_path__ + "static/media/rs.bddac7ff.svg";